import { defineStore } from "pinia";
import { markRaw } from "vue";
import { api, type Result } from "../api";
import {
  AutopayWhiteLabelResponseSchema,
  PaymentInitResponseSchema,
  type AutopayBlikWhiteLabelPayload,
  type AutopayWhiteLabelResponse,
  type PaymentInitPayload,
  type PaymentInitResponse,
} from "../schemas/payment";

class PaymentApi {
  initPayment(
    provider: string,
    payload: PaymentInitPayload,
  ): Promise<Result<PaymentInitResponse>> {
    return api.post(
      `/payments/${provider}/init/`,
      PaymentInitResponseSchema,
      payload,
    );
  }

  initAutopayBlikWhiteLabel(
    payload: AutopayBlikWhiteLabelPayload,
  ): Promise<Result<AutopayWhiteLabelResponse>> {
    return api.post(
      "/payments/autopay/blik/white-label/",
      AutopayWhiteLabelResponseSchema,
      payload,
    );
  }
}

const store = defineStore("payment", () => ({
  api: markRaw(new PaymentApi()),
}));

export function usePayments() {
  return store().api;
}
